import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import SignUpForm from './components/SignUpForm'
import SignUpInfoBox from './components/SignUpInfoBox'

import LoginTransition from '../LoginPage/components/LoginTransition'
import L1NLogoWhiteStroke from '../../svg/L1N-logo-white-stroke.svg'
import { Link } from 'react-router-dom'
import AppRoutes from '../../routes/appRoutes'
import SuccessMessageSvg from '../../svg/SuccessMessage.jsx'
import Button from '../../components/Button/Button'
import useScreen from '../../hooks/useScreen'

const SignUpPage = props => {
    const [formDefaults, setFormDefaults] = useState({})
    const { isMobile } = useScreen()
    const [signUpSuccess, setSignUpSuccess] = useState(false)
    const {
        location: { search },
        history,
    } = props

    useEffect(() => {
        const urlQueries = queryString.parse(search)
        const { company } = urlQueries ?? {}
        setFormDefaults({ company })
    }, [search])

    const renderTitle = () => {
        return (
            <div className="w-full h-auto flex flex-col items-center justify-start gap-y-4">
                <img src={L1NLogoWhiteStroke} className="h-8 w-28" />
                <h1 className="text-white font-bold sm:text-3xl text-2.5xl text-center">
                    Request Account
                </h1>
            </div>
        )
    }

    const renderContent = () => {
        if (signUpSuccess) {
            return (
                <div className="w-full flex flex-col items-center justify-between gap-y-10 sm:p-16 p-6 transition-all">
                    {renderTitle()}
                    <div className="w-full flex flex-col items-center justify-center gap-y-6">
                        <SuccessMessageSvg
                            bg="#42474D"
                            iconColor="#FFC20D"
                            border="#363A3F"
                            hasBorderOpacity={false}
                            className="w-14 h-14"
                        />

                        <div className="w-full h-auto flex flex-col items-center justify-center gap-y-2">
                            <p className="text-xl font-medium text-white text-center">
                                Your request has been sent!
                            </p>
                            <p className="text-base font-normal text-black30 text-center">
                                You will receive an email within 2 to 5 business
                                days <br />
                                inviting you to activate your LiftOne Now
                                account.
                            </p>
                            <p className="text-base font-normal text-black30 text-center">
                                Please reach out to us at{' '}
                                <span
                                    onClick={() =>
                                        (window.location =
                                            'mailto:help@liftonenow.com')
                                    }
                                    className="text-yellow underline"
                                >
                                    help@liftonenow.com
                                </span>{' '}
                                {isMobile && <br />}
                                if you need further assistance.
                            </p>
                        </div>
                    </div>

                    <Button
                        type="button"
                        variant="secondary"
                        className="w-full"
                        onClick={() => history?.push(AppRoutes.login())}
                        text="Return to Sign in"
                    />
                </div>
            )
        }
        return (
            <div className="w-full h-auto flex flex-col items-center justify-start gap-y-10 sm:p-16 p-6 transition-all">
                {renderTitle()}
                <SignUpInfoBox />

                <SignUpForm
                    defaults={formDefaults}
                    setSignUpSuccess={setSignUpSuccess}
                />
                <span className="font-normal text-sm text-white flex items-center justify-center">
                    Already have an account?{' '}
                    <Link
                        to={AppRoutes.login()}
                        className="text-yellow underline font-normal ml-1"
                    >
                        Sign in
                    </Link>
                </span>
            </div>
        )
    }

    return <LoginTransition>{renderContent()}</LoginTransition>
}

SignUpPage.propTypes = {
    location: PropTypes.shape({
        search: PropTypes.string,
    }),
    history: PropTypes.shape({
        push: PropTypes.func,
    }),
}

export default SignUpPage
